module.exports = __webpack_public_path__ + "img/defaultprofile.c157d1d2.svg";